export const getUseGetDistributorsQueryKey = () => ['distributors'];
export const getUseGetPreferredDistributorQueryKey = () => [
  'preferredDistributor',
];
